<template>
  <section>
    <el-tabs v-model="appealType">
      <el-tab-pane label="企业诉求意见登记" name="appealInfo">
        <PortalEnterpriseAppeal/>
      </el-tab-pane>
      <el-tab-pane label="保障款项支付登记" name="payInfo" lazy="true">
        <PortalPaymentAppeal/>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>
<script>
  import PortalEnterpriseAppeal from '@/components/portal/PortalEnterpriseAppeal'
  import PortalPaymentAppeal from '@/components/portal/PortalPaymentAppeal'
  export default {
    components: {
      PortalEnterpriseAppeal,
      PortalPaymentAppeal
    },
    data () {
      return {
        appealType: 'appealInfo'
      }
    },
    mounted () {
    },
    methods: {

    }
  }
</script>
<style>
  .el-tabs {
    background: #FFFFFF;
    padding: 10px;
  }
  .el-tabs__active-bar {
    background-color: #aa051a;
    height: 4px;
  }
  .el-tabs__item {
    font-size: 15px;
  }
  .el-tabs__item.is-active {
    color: #07438A;
  }
  .appeal-info {
    font-size: 13px;
  }
  .fill-hint {
    font-size: 10px;
    color: #FF0000;
    margin: 10px 0;
  }
  .payInfoTag {
    color: #0068BC;
    border: 1px solid #0068BC;
    font-size: 15px;
    margin-left: 50px;
    border-radius: 5px;
    background: #f4fbfe;
    padding: 3px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/AppealInfo.vue